import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PictureComponent } from '../../../shared/components/picture/picture.component';

@Component({
  selector: '[section1]',
  imports: [PictureComponent],
  templateUrl: './section1.component.html',
  styleUrl: './section1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: 'know-your-options',
  },
})
export class Section1Component {
  cardButton = {
    buttonLabel: 'View video',
    buttonUrl: '',
    openInNewTab: false,
    buttonIcon: 'right-icon',
    videoAmanda: true,
  };
}
